module.exports = __webpack_public_path__ + "img/408.495d4210.png";